<template>
    <div>
        <template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }" >
                <b-form @submit.prevent="handleSubmit(submitProductMaterial)">
                    <b-row >
                        <b-col cols="auto" md="6">
                            
                            <!-- Code Fabric -->
                            <validation-provider
                                name="codeFabric"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Code
                                    </template>
                                    
                                        <!-- <b-form-select id="inputCodeFabric" v-model="form.codeFabric"  :options="codeOpt" :state="getValidationState(validationContext)"  trim></b-form-select> -->
                                        <v-select append-to-body
                                            :reduce="ref => ref.code" 
                                            v-model="form.codeFabric"
                                            @input="setSelected" 
                                            :options="codeOpt" 
                                            placeholder="Type your code number"
                                            label="ref">
                                            <template #list-header>
                                                <b-input-group-append>
                                                    <b-button block variant="light" @click="showMaster()">
                                                        <!-- <b-icon icon="eye-fill" aria-label="Help"></b-icon> -->
                                                        Lihat Semua
                                                    </b-button>
                                                </b-input-group-append>
                                            </template>
                                            <template #option="{ code, description }">
                                                <p style="margin: 0">{{ code }}</p>
                                                <em class="text-muted">{{ description }}</em>
                                            </template>
                                        </v-select>
                                        
                                    
                                    <b-form-invalid-feedback id="inputCodeFabric">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Type Fabric -->
                            <validation-provider
                                name="TypeFabric"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4"  
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Type
                                    </template>
                                
                                    <b-form-input readonly id="inputTypeFabric" v-model="form.typeFabric"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                    <b-form-invalid-feedback id="inputTypeFabric">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Description -->
                            <validation-provider
                                name="DescriptionFabric"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Description
                                    </template>
                                
                                    <b-form-input readonly id="DescriptionFabric" v-model="form.descriptionFabric"  :state="getValidationState(validationContext)"  trim></b-form-input>
                                    <b-form-invalid-feedback id="DescriptionFabric">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <!-- Detail Fabric -->
                            <validation-provider
                                name="DetailFabric"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Detail
                                    </template>
                                
                                    <b-form-textarea id="DetailCodeFabric" v-model="form.detailFabric"  :state="getValidationState(validationContext)"  trim></b-form-textarea>
                                    <b-form-invalid-feedback id="DetailCodeFabric">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                name="UsedFabric"
                                :rules="{ required: false }"
                                v-slot="validationContext"
                            >
                                <b-form-group 
                                    label-cols          ="4" 
                                    label-cols-lg       ="4" 
                                    label-size          ="sm"
                                >
                                    <template v-slot:label>
                                        Used As
                                    </template>
                                    <b-form-select id="inputUsedFabric" v-model="form.usedFabric"  :options="usedOpt" :state="getValidationState(validationContext)"  trim></b-form-select>
                                    <b-form-invalid-feedback id="inputUsedFabric">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <b-form-group
                                label-cols          ="4" 
                                label-cols-lg       ="4" 
                                label-size          ="sm"
                            >
                                <template v-slot:label>
                                    Images
                                </template>
                                    <b-img v-bind="mainProps" thumbnail fluid :src="form.imagesFabric" ></b-img>

                            </b-form-group>
                            
                            <div>
                                <b-button block  variant="warning" v-on:click="clearForm()">Cancel</b-button>
                                <b-button block  variant="success" type="submit">Save</b-button>
                            </div>
                            
                        </b-col>
                        <b-col cols="auto" md="6">
                            <b-card sub-title="Material History">
                                <b-table
                                    responsive
                                    show-empty
                                    small
                                    fixer
                                    :items="loadMaterialHistory"
                                    :fields="fieldsApprove"
                                >
                                    <template #empty="scope">
                                        <p class="text-center">
                                        Waiting For Approval
                                        </p>
                                    </template>
                                    <template #cell(date)='{item}'>
                                        {{new Date(item.date).toLocaleString("id-ID")}}
                                    </template>
                                </b-table>
                            </b-card>
                        </b-col>
                    </b-row>
                        
                </b-form>
            </validation-observer>
        </template>
        <template>
            <b-table
                responsive
                striped 
                hover
                :items="loadProductMaterial"
                :fields="fields"
                show-empty
            >
                
                <template #cell(images)="{item}"   >
                    <p class="small" v-for="img in item.images" :key="img.src">
                        <a :href="img.src" target="_blank">{{img.fileName.substring(0,26)}}</a>
                    </p>
                </template>
                <template #cell(actions)="{item}">
                    <b-button title="Hapus" size="xs" variant="danger" v-on:click="updateMaterial(item.product_material_id)">
                        <b-icon icon="trash-fill" aria-label="Help"></b-icon>
                    </b-button>
                    <b-button title="Ubah" size="xs" variant="warning" v-on:click="editData(item.product_material_id)">
                        
                        <b-icon icon="pencil-square" aria-label="Help"></b-icon>
                        
                    </b-button>
                    <b-button title="View" size="xs" variant="dark" v-on:click="modalFabricView = true">
                        
                        <b-icon icon="eye-fill" aria-label="Help"></b-icon>
                    </b-button>
                </template>
            </b-table>
        </template>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import 'vue-select/dist/vue-select.css';
export default {
    props:['productId'],
    data(){
        return{
            mainProps: {width: 150, class: 'm1' },
            formName: 'Fabric',
            modulName: null,
            tabIndex:1,
            isValid:false,
            dataFabric:[],
            
            fields:[
                {key:'actions', label:'#'},
                'code','type','description',
                {key:'images', label:'Images'},
                'detail',
                'used_as'
            ],
            imagesUrl:[],
            form:{
                productMaterialId:null,
                codeFabric:null,
                typeFabric:null,
                imagesFabric:[],
                detailFabric:null,
                usedFabric:null,
                descriptionFabric:null,
                fabricId:null,
                category:'fabric',
                statusFabric:null,
                
            },
            codeOpt:[
                {code:'Code A', ref:'Code A'},
                {code:'Code B', ref:'Code B'},
                {code:'Code C', ref:'Code C'},
                {code:'Code D', ref:'Code D'},
                
            ],
            usedOpt:[
                {value:'Main', text:'Main'},
                {value:'Combo 1', text:'Combo 1'},
                {value:'Combo 2', text:'Combo 2'},
                {value:'Combo 3', text:'Combo 3'},
            ],
            fabricOpt: [
                { item: 'tbd', name: 'TBD', notEnabled: true },
                { item: 'yes', name: 'Yes' },
                { item: 'no', name: 'No', notEnabled: true},
                
            ],
            isSelect:'yes',
            modalMaster:false,
            modalFabricView:false,
            materialHistory:[],
            fieldsApprove:[
                {key:'date',label:'Date'},
                'status','comment','code'
                // {key:'created_by', label:'Approve By'}
            ],
        }
    },
    methods:{
        ...mapActions('productDesign',['GET_PRODUCT_MATERIAL_DEV','POST_PRODUCT_MATERIAL','PUT_PRODUCT_MATERIAL','GET_MATERIAL_APPROVE']),
        ...mapActions('masterPLM',['GET_MASTER_MATERIAL']),
        
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        getProductMaterial(){
            // console.log('id',this.productId);
            this.GET_PRODUCT_MATERIAL_DEV({
                product:this.productId
            }).then(rsp=>{
                // console.log('data',rsp.data.payload.filter(i=>i.category ==='fabric' ))
                let data = rsp.data.payload.filter(i=>i.category ==='fabric' && i.product_id === this.productId && i.img_label === 'images')
                this.dataFabric = data
            }).catch(err=>{
                return err
            })
        },
        getFabricMaster(){
            this.GET_MASTER_MATERIAL().then(response => {
                this.codeOpt = []
                    let objFabric = response.data.payload.filter(x=>x.category === 'fabric')
                    for(var i=0;i<objFabric.length;i++){
                        
                            let arrFabric = {
                                ref: objFabric[i].code,
                                code: objFabric[i].code,
                                description: objFabric[i].description,
                            }
                            this.codeOpt.push(arrFabric)
                    }
                    
            })
            .catch(error => {
                if (error.response.status === 400){
                     this.errorMessage = error.response.data.message
                }
            })
        },
        clearForm(){
            this.form.indexId = null
            this.form.codeFabric = null
            this.form.typeFabric = null
            this.form.imagesFabric = []
            this.imagesUrl = []
            this.form.detailFabric = null
            this.form.usedFabric = null
            this.form.fabricId = null
            this.form.descriptionFabric = null
            this.form.productMaterialId     = null
            this.form.statusFabric = null
            this.$refs.observer.reset()
        },
        setSelected(value){
            console.log(value);
            if(value != null){
                let dataFabric = this.MASTER_MATERIAL.filter(x => x.code === value)
                // console.log(dataFabric);
                this.form.fabricId= dataFabric[0].id
                this.form.codeFabric= dataFabric[0].code
                this.form.typeFabric= dataFabric[0].type
                this.form.descriptionFabric = dataFabric[0].description
                this.form.imagesFabric = dataFabric[0].img_src
            }else{
                console.log('belum ada data')
            }
        },
        submitProductMaterial(){
                let productMaterial = []
                let fabric = {
                    category: this.form.category,
                    material_id: this.form.fabricId,
                    code: this.form.codeFabric,
                    type: this.form.typeFabric,
                    used_as: this.form.usedFabric,
                    detail: this.form.detailFabric,
                    description: this.form.descriptionFabric,
                    status:'new',
                    is_proccess:'active'
                }    
                productMaterial.push(fabric)

            if(this.form.productMaterialId){
                this.PUT_PRODUCT_MATERIAL({
                    product_material_id:this.form.productMaterialId,
                    detail:this.form.detailFabric,
                    used_as:this.form.usedFabric,
                    process:this.form.statusFabric
                }).then(rsp=>{
                    console.log('berhasil dihapus');
                    this.getProductMaterial()
                    this.clearForm()
                })
            }else{
                this.POST_PRODUCT_MATERIAL({
                product_id:this.productId,
                material:productMaterial

            })
                .then(response => {
                    console.log('success submit product material');
                    this.getProductMaterial()
                    this.clearForm()
                })
                .catch(error => {
                    console.log('material save',error);
                })
            }  
            
        },
        editData(id){
            let data = this.dataFabric.filter(i=>i.product_material_id === id)
            // console.log('edit data',data);

            this.form.productMaterialId     = id
            this.form.fabricId              = data[0].id
            this.form.codeFabric            = data[0].code
            this.form.typeFabric            = data[0].type
            this.form.detailFabric          = data[0].detail
            this.form.usedFabric            = data[0].used_as
            this.form.descriptionFabric     = data[0].description
            this.form.statusFabric          = data[0].product_material_proccess
        },
        updateMaterial(id){
            this.PUT_PRODUCT_MATERIAL({
                product_material_id:id,
                detail:this.form.detailFabric,
                used_as:this.form.usedFabric,
                process:'drop'
            }).then(rsp=>{
                console.log('berhasil dihapus');
                this.getProductMaterial()
                this.clearForm()
            })
        },
        getMaterialHistory(){
            this.GET_MATERIAL_APPROVE({product:this.productId})
            .then(rsp=>{
                
                this.$set(this,'materialHistory',rsp.data.payload)
            }).catch(err=>{
                return err
            })
        },

    },
    created(){
        this.getProductMaterial()
        this.getFabricMaster()
        this.getMaterialHistory()
    },
    computed:{
        
        ...mapGetters('masterPLM',['MASTER_MATERIAL']),
        ...mapGetters('productDesign',['GET_MATERIAL_HISTORY']),
        loadProductMaterial(){
           
            return this.dataFabric
        },
        loadMaterialHistory(){
            
            return this.GET_MATERIAL_HISTORY.filter(i=>i.category === 'fabric')
        }
    }
}
</script>